
import axios from 'axios';
import Constants from "../../utils/Constantes";

const API_URL = Constants.api_url;
const URL_REFRESH_TOKEN = `${API_URL}/auth/refresh`;
const URL_LOGOUT = `${API_URL}/auth/logout`;
const URL_TOKEN_EXPIRED = `/tokenexp`;

axios.defaults.withCredentials = true;

let isRefreshing = false;
let refreshSubscribers = [];

function onRefreshed() {
  refreshSubscribers.forEach(callback => callback());
  refreshSubscribers = [];
}

function addRefreshSubscriber(callback) {
  refreshSubscribers.push(callback);
}

// Interceptor de respuesta global (SERGIO)
// axios.interceptors.response.use(
//   response => response,
//   async error => {
//     const { config, response } = error;

//     if (!response) {
//       // console.error("Error de red o CORS", error);
//       return Promise.reject(error);
//     }

//     if (config.url.includes("/auth/refresh") || config.url.includes("/auth/logout")) {
//       return Promise.reject(error);
//     }

//     if (response.status === 401 && !config._retry) {
//       if (isRefreshing) {
//         return new Promise(resolve => {
//           addRefreshSubscriber(() => resolve(axios(config)));
//         });
//       }

//       config._retry = true;
//       isRefreshing = true;

//       try {
//         await axios.post(URL_REFRESH_TOKEN, {}, { withCredentials: true });
//         isRefreshing = false;
//         onRefreshed();
//         return axios(config);
//       } catch (refreshError) {
//         isRefreshing = false;

//         try {
//           localStorage.clear();
//           await axios.post(URL_LOGOUT, {}, { withCredentials: true });
//         } catch (logoutError) {
//           // console.error("Error al hacer logout", logoutError);
//         }

//         window.location.href = URL_TOKEN_EXPIRED;
//         return Promise.reject(refreshError);
//       }
//     }

//     return Promise.reject(error);
//   }
// );


// Interceptor de respuesta global (Antiguo)
axios.interceptors.response.use(
  response => response,
  async error => {
    const { config, response } = error;
    

    

    // if (!response) {
    //   // console.error("Error de red o CORS", error);
    //   return Promise.reject(error);
    // }

    if (config.url.includes("/auth/refresh") || config.url.includes("/auth/logout")) {
      return Promise.reject(error);
    }

    if (!response) {
      // Error de red o CORS
      // // console.error("🌐 Error de red o CORS:", error.message);
      window.dispatchEvent(
        new CustomEvent("showErrorModal", {
          detail: {
            content: "No se pudo conectar con el servidor. Verifica tu conexión.",
            tipo: "tituloModal rojo",
            destinoAviso: null,
            destinoCerrar: null
          },
        })
      );
      return Promise.reject(error);
    }

    const { status, statusText } = response;

    // Diccionario de mensajes por código HTTP
    const mensajes = {
      //300
      300: "Múltiples opciones: el recurso solicitado tiene varias representaciones.",
      301: "Recurso movido permanentemente a otra URL.",
      302: "Recurso encontrado temporalmente en una ubicación diferente.",
      303: "Ver otro recurso: redirección a otra URL mediante GET.",
      304: "No modificado: el recurso no ha cambiado desde la última solicitud.",
      305: "Debe accederse al recurso mediante un proxy.",
      306: "Código obsoleto: ya no se usa, reservado para uso futuro.",
      307: "Redirección temporal: use la nueva URL sin cambiar el método HTTP.",
      308: "Redirección permanente: el recurso se ha movido definitivamente (método conservado).",

      //400
      400: "La solicitud es incorrecta o contiene datos no válidos.",
      403: "No tienes permisos para acceder a este servicio.",
      404: "El recurso solicitado no existe.",
      405: "El método no está permitido para este recurso.",
      406: "El formato solicitado no es aceptable.",
      407: "Se requiere autenticación de proxy.",
      408: "La solicitud ha expirado. Inténtelo de nuevo.",
      409: "Conflicto de datos: puede que ya exista un registro similar.",
      410: "El recurso solicitado ya no está disponible permanentemente.",
      411: "Se requiere especificar la longitud del contenido (Content-Length).",
      412: "Precondición fallida: una condición enviada por el cliente no se cumplió.",
      413: "El cuerpo de la solicitud es demasiado grande.",
      414: "La URL solicitada es demasiado larga.",
      415: "El tipo de contenido no es compatible con el servidor.",
      416: "El rango solicitado no es válido o no está disponible.",
      417: "La expectativa indicada en la cabecera Expect falló.",
      421: "La solicitud fue enviada a un servidor incorrecto.",
      422: "Entidad no procesable: los datos están bien formados pero no se pueden procesar.",
      423: "El recurso está bloqueado y no puede modificarse.",
      424: "Error de dependencia: la solicitud dependía de otra que falló.",
      425: "Demasiado temprano: el servidor no está listo para procesar la solicitud.",
      426: "Se requiere actualización de protocolo (Upgrade).",
      428: "Precondición requerida: falta una condición necesaria para procesar.",
      429: "Demasiadas solicitudes: limite la frecuencia de peticiones.",
      431: "Los encabezados de la solicitud son demasiado grandes.",
      451: "El recurso no está disponible por razones legales.",

      //500
      500: "Error interno del servidor. Inténtelo de nuevo más tarde.",
      501: "Funcionalidad no implementada o no soportada por el servidor.",
      502: "Puerta de enlace incorrecta: el servidor recibió una respuesta no válida.",
      503: "Servicio no disponible: el servidor está sobrecargado o en mantenimiento.",
      504: "Tiempo de espera de la puerta de enlace agotado.",
      505: "Versión HTTP no soportada.",
      506: "Error de configuración interna.",
      507: "Espacio insuficiente en el servidor para completar la solicitud.",
      508: "Bucle detectado en la solicitud (loop infinito).",
      510: "Extensión no soportada: se requieren parámetros adicionales.",
      511: "Autenticación de red requerida para acceder al recurso.",


    };

    const mensaje = mensajes[status] || `Error inesperado (${statusText || "Desconocido"})`;

    // Log global
    // // console.error(`❗ Error HTTP ${status}: ${mensaje}`, data);

    if (response.status !== 401) {
      // Mostrar modal con mensaje en español
      window.dispatchEvent(
        new CustomEvent("showErrorModal", {
          detail: {
            content: mensaje,
            tipo: "tituloModal rojo",
            destinoAviso: null,
            destinoCerrar: null,
          },
        })
      );
    }


    if (response.status === 401 && !config._retry) {
      if (isRefreshing) {
        return new Promise(resolve => {
          addRefreshSubscriber(() => resolve(axios(config)));
        });
      }

      config._retry = true;
      isRefreshing = true;

      try {
        await axios.post(URL_REFRESH_TOKEN, {}, { withCredentials: true });
        isRefreshing = false;
        onRefreshed();
        return axios(config);
      } catch (refreshError) {
        isRefreshing = false;

        try {
          localStorage.clear();
          await axios.post(URL_LOGOUT, {}, { withCredentials: true });
        } catch (logoutError) {
          // // console.error("Error al hacer logout", logoutError);
        }

        window.location.href = URL_TOKEN_EXPIRED;
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);


// Interceptor de respuesta global
// axios.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const { config, response } = error;

//     // 🔸 Sin respuesta (error de red o CORS)
//     if (!response) {
//       // console.error("Error de red o CORS", error);
//       return Promise.reject(error);
//     }

//     // 🔸 Ignorar rutas específicas
//     if (
//       config.url.includes("/auth/refresh") ||
//       config.url.includes("/auth/logout")
//     ) {
//       return Promise.reject(error);
//     }

//     // 🔸 Manejo de 403 (sin permisos)
//     if (response.status === 403) {
//       window.dispatchEvent(
//         new CustomEvent("show403Modal", {
//           detail: {
//             content: "No tienes permisos para acceder a este servicio.",
//             tipo: "tituloModal rojo",
//             destinoAviso: "/home",
//             destinoCerrar: "/home",
//           },
//         })
//       );
//       return Promise.reject(error);
//     }

//     // 🔸 Manejo de 401 (token expirado o sesión inválida)
//     if (response.status === 401 && !config._retry) {
//       const token = localStorage.getItem("token");

//       // ⚠️ Si no hay token, el usuario no está logado: no redirigir
//       if (!token) {
//         return Promise.reject(error);
//       }

//       // ⚠️ Evitar bucles en páginas públicas
//       const publicPaths = ["/login", "/tokenexp"];
//       if (publicPaths.includes(window.location.pathname)) {
//         return Promise.reject(error);
//       }

//       // 🔁 Intentar refrescar token
//       if (isRefreshing) {
//         return new Promise((resolve) => {
//           addRefreshSubscriber(() => resolve(axios(config)));
//         });
//       }

//       config._retry = true;
//       isRefreshing = true;

//       try {
//         await axios.post(URL_REFRESH_TOKEN, {}, { withCredentials: true });
//         isRefreshing = false;
//         onRefreshed();
//         return axios(config);
//       } catch (refreshError) {
//         isRefreshing = false;

//         try {
//           // ⚙️ Si el refresh falla → logout y redirección controlada
//           localStorage.clear();

//           if (window.location.pathname !== URL_TOKEN_EXPIRED) {
//             // Evitar redirección repetida
//             if (!sessionStorage.getItem("tokenExpiredHandled")) {
//               sessionStorage.setItem("tokenExpiredHandled", "1");
//               window.location.href = URL_TOKEN_EXPIRED;
//             }
//           }

//           await axios.post(URL_LOGOUT, {}, { withCredentials: true });
//         } catch (logoutError) {
//           // console.error("Error al hacer logout", logoutError);
//         }

//         return Promise.reject(refreshError);
//       }
//     }

//     return Promise.reject(error);
//   }
// );
